import _each from "lodash/each";
import _uniqBy from "lodash/uniqBy";

export default {
  words: (state, words) => {
    state.words = words

    const opts = [];
    const pos = {
      fw: 'function word',
      v: 'verb',
      r: 'adverb',
      n: 'noun',
      j: 'adjective',
      u: 'interjection',
      m: 'number',
      K: 'proper noun',
      abbr: 'abbreviation',
    }
    _each(words, word => {
      opts.push({word: `${word.lemma} (${pos[word.pos]})`, value: `${word.lemma}|${word.pos}`, real_word: word.lemma});
      for (const inf in word.inf) {
        opts.push({word: `${inf} (${pos[word.pos]})`, value: `${word.lemma}|${word.pos}`, real_word: inf});
      }
    });

    state.wordOpts = _uniqBy(opts, opt => opt.word);
  },

  toggleVideoSeen:  (state, words) => {
    state.videoSeen = !state.videoSeen
  }
}



// WEBPACK FOOTER //
// ./src/store/mutationsV2.js